<button id="search"
        class="btn btn-light hstack"
        style="width: 185px; height: 30px; border-radius: 0.25rem !important"
        [stickyPopover]="popContent"
        [autoClose]="false"
        [animation]="false"
        popoverClass="search-popover"
        container="body"
        triggers="manual"
        placement="bottom-start">
  <span class="text-black-50">Search</span>
  <div class="mx-2 ms-auto"></div>
  <i class="fa-light fa-magnifying-glass"></i>
</button>

<ng-template #popContent>
  <ng-content select="content"></ng-content>
</ng-template>
